import {
  externalConfirmationPathSelector,
  internalConfirmationPathSelector
} from 'selectors/url'
import { eventTypeSelector } from 'root-api'

const scheduleExternalRedirect = (getState, formData = {}) => {
  setTimeout(
    () => {
      window.top.location.href = externalConfirmationPathSelector(getState(), { formData })
    },
    3000
  )
}

export const completeExternalRedirectFlow = () => (dispatch, getState) => {
  const formData = getState().scheduling.externalRedirectFormData || {}

  dispatch({ type: 'SCHEDULING_FINISH_PHONE_VERIFICATION' })
  scheduleExternalRedirect(getState, formData)
}

export const navigateToConfirmationPage = (formData) => (dispatch, getState, { history }) => {
  const state = getState()
  switch (eventTypeSelector(state).confirmation_page_type) {
    case 'internal':
      history.push(internalConfirmationPathSelector(state))
      break
    case 'external':
      if (state.scheduling.invitee?.pending_phone_verification === true) {
        dispatch({ type: 'SCHEDULING_SHOW_PHONE_VERIFICATION', payload: { formData } })
      } else {
        dispatch({ type: 'SCHEDULING_SHOW_EXTERNAL_REDIRECT' })
        scheduleExternalRedirect(getState, formData)
      }
      break
    default:
      throw new Error('Unsupported confirmation page type')
  }
}
